import React, { useState } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { EmptyPage } from '../EmptyPage';
import { useSelector } from 'react-redux';
import { CreateUser } from './CreateUser';
import { accessor } from '../../helpers';
import { EditUser } from './EditUser';
import {ReactComponent as Bin} from '../../assets/bin.svg';
// import Bin from '../../assets/bin.svg';
import { Button } from '../../components/Button';
import { Select } from '../../components/Select';
import { Input } from '../../components/Input';

const UserCard = ({ user, thisUserId }) => {
    const appAccess = user.role.permissions.CAN_USE_APP.flag;
    const isThisUser = thisUserId === user._id;
    return (
        <Link to={user._id} className="user-card dark-theme-bg0-hover-bg1">
            {isThisUser &&<p className='user-card__this-user'>Это вы</p>}
            <section>
                <h4>{user.fullname}</h4>
                <p>
                    {user.role.name}, {user.city.name}
                </p>
                <p>Уровень привилегий: {user.role.privilegeLevel}</p>
            </section>
            <section className="profiles">
                {user.profiles.length ? (
                    <b>{user.profiles.map((p) => p.name).join(', ')}</b>
                ) : (
                    'Нет рабочих профилей'
                )}
            </section>
            {appAccess && (
                <section>
                    <p style={{ color: 'yellow' }}>доступ к системе</p>
                </section>
            )}
        </Link>
    );
};

const UserList = ({list}) => {
    const userInfo = useSelector((state) => state.auth);
    const hasCreateUserAccess = accessor.createUser(userInfo);

    const userCities = useSelector((state) => state.settings.userCities);
    const cityList = userCities.length ? userCities : [{_id: 'null', name: 'Нет доступных городов', UTC: 0}];
    const [city, setCity] = useState(cityList[0]._id);

    const [showDeleted, setShowDeleted] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const displayList = list.filter((u) => u.deleted === showDeleted && u.city._id === city && u.fullname.toLowerCase().includes(searchVal.toLowerCase()));
  return (
    <div className='users'>
        <div className="users__header">
            <div className="users__select-city">
                <Select enums={cityList} value={city} changeHandler={(e) => setCity(e.target.value)} />
            </div>
            <div className="users__search">
                <Input placeholder='поиск' value={searchVal} changeHandler={(e) => setSearchVal(e.target.value)} />
            </div>
            {!showDeleted && <div className="users__deleted-button button" onClick={() => setShowDeleted(true)}>
                <Bin width={19} height={19}/>
                удаленные пользователи
            </div>}
            {showDeleted && <Button text='← к пользователям' onClick={() => setShowDeleted(false)}/>}
        </div>
      <div className="users__list">
        {hasCreateUserAccess && !showDeleted && <Link to="new" className='user-card dark-theme-bg0-hover-bg1 add-user'>+ Новый пользователь</Link>}
        {displayList.map(u => <UserCard key={u._id} user={u} thisUserId={userInfo.id} />)}
      </div>
    </div> 
  )
}

const UserPage = () => {
    const { pathname } = useLocation();
    const userId = pathname.split('/')[pathname.split('/').length-1]
    return userId === 'new' ? <CreateUser /> : <EditUser />
}

export const Users = () => {
    const availableUsers = useSelector((state) => state.settings.availableUsers);
    const userList = useSelector((state) => state.users.list).filter(u => availableUsers.some(u2 => u2._id === u._id));
    const displayList = [...userList]
        .sort((u1, u2) => u2.role.privilegeLevel - u1.role.privilegeLevel)

    const userInfo = useSelector((state) => state.auth);
    const usersInteractAccess = accessor.usersInteract(userInfo);

    if (!usersInteractAccess) {
        return <EmptyPage message="Нет доступа для взаимодействия с пользователями"/> 
    }

    return (
        <Routes>
            <Route path="/" element={<UserList list={displayList} />} />
            <Route path=":id" element={<UserPage />} />
            <Route path="*" element={<EmptyPage message="Страница не найдена" />} />
        </Routes>
    );
};
